import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import defaultAvatar from '@/assets/img/avatar.png';
import { useBasicStore } from '@/stores/basic';
import { UserInfo,useRoomStore } from '@/stores/room';
import { storeToRefs } from 'pinia';
import { ICON_NAME } from '@/constants/icon';
import { ETUIRoomRole } from '../../../tui-room-core';
import SvgIcon from '../../common/SvgIcon.vue';

interface Props {
  userInfo: UserInfo,
  showMemberControl: Boolean,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'memberInfo',
  props: {
    userInfo: null,
    showMemberControl: null
  },
  setup(__props: any) {

const props = __props as {
  userInfo: UserInfo,
  showMemberControl: Boolean,
}

const roomStore = useRoomStore();
const { userList, userNumber, applyToAnchorList,remoteUserObj } = storeToRefs(roomStore);

const list=ref([])
for(let i in remoteUserObj.value){
  if(remoteUserObj.value[i].isGrantAnchor==true){
    list.value.push(remoteUserObj.value[i])
  }
}





const basicStore = useBasicStore();
const { isMaster } = storeToRefs(basicStore);

const isMe = computed(() => basicStore.userId === props.userInfo.userId);


return { __sfc: true,roomStore, userList, userNumber, applyToAnchorList, remoteUserObj, list, props, basicStore, isMaster, isMe, defaultAvatar, ICON_NAME, ETUIRoomRole, SvgIcon }
}

})